module.exports = __webpack_public_path__ + "static/features-slide1-a39dc5c0f30e0e78427642e1b03b80c2.png";